import "../../App.css";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import ModalSelectJens from "../../components/Modal/Jens/JensSelectModal";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import Cookies from "js-cookie";
import ModalMachine from "../../components/Modal/Machine/ModalMachine";
import ModalDriverSingle from "../../components/Modal/Driver/DriverSingle";
import ModalSelectDestination from "../../components/Modal/Destination/DestinationSelectModal";
import ModalSelectOrigin from "../../components/Modal/Origin/OriginSelectModal";
import { deleteRecordByCode, getMatchingPlates, savePayload } from "../../actions/payload/crypt-payload";
import { pdf } from "@react-pdf/renderer";
import moment from "moment-jalaali";
import { getMachineData } from "../../actions/weight-bridge/weight-bridge";
import ModalSelectJensCode from "../../components/Modal/JensCodes/JensCodeSelectModal";
import PdfReceiptWeight from "../../actions/pdf_part/PdfReceiptWeight/PdfReceiptWeight";

import { Badge, Button, Card, Col, Divider, Input, Row, Select, Space, Spin, Switch, Typography } from "antd";
import { CameraOutlined, ClearOutlined, LoadingOutlined, PrinterOutlined, SaveOutlined } from "@ant-design/icons";
import { getPurchasor } from "../../actions/purchasor/purchasor";
import { getJens } from "../../actions/reports/jens";

const { Text } = Typography;
const { Option } = Select;

export default function WeightBridgePage() {
  const [data, setData] = useState({ id: "", title: "" });
  const [dataJensCode, setDataJensCodes] = useState({ id: "", title: "" });
  const [openModal, setOpenModal] = useState(false);
  const [openModalJensCode, setOpenModalJensCodes] = useState(false);
  const [loadingAi, setLoadingAi] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [serial, setSerial] = useState("");
  const [firstTwoDigits, setFirstTwoDigits] = useState("");
  const [middleThreeDigits, setMiddleThreeDigits] = useState("");
  const [letterDigit, setLetterDigit] = useState("");
  const [lastTwoDigits, setLastTwoDigits] = useState("");
  const [weight, setWeight] = useState(null);
  const [connected, setConnected] = useState(false);
  const [grossWeight, setGrossWeight] = useState(""); // توزین خالی (weight_empty)
  const [netWeight, setNetWeight] = useState(""); // توزین پر (weight_fill)
  const [origin, setOrigin] = useState(""); // مبدا
  const [destination, setDestination] = useState(""); // مقصد
  const [driverName, setDriverName] = useState("");  // راننده
  const [buyerName, setBuyerName] = useState(""); // مشتری
  const [selectedValue, setSelectedValue] = useState("1");
  const [machine, setMachine] = useState({id:"",title:""});
  const [imageName, setImageName] = useState([""]);
  const [openModalMachine, setOpenModalMachine] = useState(false);
  const [openModalDriver, setOpenModalDriver] = useState(false);
  const [openModalDestination, setOpenModalDestination] = useState(false);
  const [openModalOrigin, setOpenModalOrigin] = useState(false);
  const [autoFill, setAutoFill] = useState(false);
  const [imagePlate, setImagePlate] = useState("");
  const ws = useRef(null);
  const [purchasors, setPurchasors] = useState([]);
  const [jenss, setJenss] = useState([]);

  const handleSearchPurchasors = async (value) => {

    const response = await getPurchasor(1, value);
    setPurchasors(response?.message?.data);
  };
  const handleSearchJens = async (value) => {

    const response = await getJens(value);
    console.log(response);
    setJenss(response?.data?.data);
  };
  useEffect(() => {
    const connect = () => {
      const socket = new WebSocket("ws://195.211.44.20:18080/ws/frontend");
      ws.current = socket;

      socket.onopen = () => {
        setConnected(true);
        console.log("✅ Connected to server");
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);

        if (data.type === "weight") {
          setWeight(data.value);
        } else if (data.type === "camera_result") {
          let imageUrl = data.image_url;

          if (imageUrl) {
            imageUrl = imageUrl
              .replace("http://127.0.0.1:5000/", "http://195.211.44.20:5010/")
              .replace("http://localhost:5000/", "http://195.211.44.20:5010/");

            if (!imageUrl.startsWith("http")) {
              imageUrl = "http://195.211.44.20:5010/" + imageUrl.replace(/^\/+/, "");
            }
          }
          if (imageUrl && imageUrl.includes("saved_images")) {
            imageUrl = imageUrl.replace("/saved_images", "");
          }

          if (imageUrl && imageUrl.includes("saved_images")) {
            const fileName = imageUrl.split("/saved_images/")[1];
            imageUrl = "http://195.211.44.20:5010/" + fileName;
          }
          setLoadingAi(false);
          setImagePlate(imageUrl);
          setImageName(() => (imageUrl ? [imageUrl] : []));

          if (data.plate_number === "پلاکی یافت نشد") {
            toast.error("در تصویر پلاکی یافت نشد");
            return;
          }

          const cleanedPlate = data.plate_number.replace(/\s+/g, "");
          const formattedPlate = `${cleanedPlate.slice(6, 8)}${cleanedPlate.slice(3, 6)}${cleanedPlate.slice(2, 3)}${cleanedPlate.slice(0, 2)}`;

          setLastTwoDigits(cleanedPlate.slice(6, 8));
          setMiddleThreeDigits(cleanedPlate.slice(3, 6));
          setLetterDigit(cleanedPlate.slice(2, 3));
          setFirstTwoDigits(cleanedPlate.slice(0, 2));
          setSerial(formattedPlate);
        }
      };

      socket.onclose = () => {
        setConnected(false);
        console.log("⚠️ Disconnected, retrying in 3s...");
        setTimeout(connect, 3000);
      };

      socket.onerror = () => socket.close();
    };

    connect();
    return () => ws.current?.close();
  }, []);

  const handleReadPlate = () => {
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      setLoadingAi(true);
      ws.current.send(JSON.stringify({ type: "takeCamera" }));
      console.log("📸 Request sent to take camera picture");
    } else {
      console.error("❌ WebSocket is not connected");
      toast.error("ارتباط با دوربین برقرار نیست");
    }
  };

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  useEffect(() => {
    if (
      firstTwoDigits.length === 2 &&
      middleThreeDigits.length === 3 &&
      letterDigit.length === 1 &&
      lastTwoDigits.length === 2
    ) {
      const pelak = `${firstTwoDigits}${letterDigit}${middleThreeDigits}${lastTwoDigits}`;
      const data = getMatchingPlates(pelak);
      console.log(data);

      const getMachineDatas = async () => {
        const data = await getMachineData(pelak);
        if (data.message) {
          setMachine({ title: data?.message?.data?.name, id: data?.message?.data?.id });
          const driver = data?.message?.data?.drivers[0] ?? null;
          if (driver) {
            setDriverName({ title: driver?.name, id: driver?.id });
          }
          setGrossWeight(data?.message?.data?.empty_weight ?? 0);
        }
      };

      if (data) {
        const payload = data[0];
        if (payload) {
          setDriverName(payload.driver);
          setData(payload.jens);
          // setDataJensCodes(payload.jens_code_id);
          setMachine({id:payload?.machine?.id,title:payload?.machine?.name});
          setOrigin(payload.origin);
          setDestination(payload.destination);
          setGrossWeight(payload.weight_empty);
          setNetWeight(payload.weight_fill);
          setSelectedValue(payload.type);
          setBuyerName(payload.buyer_name);
          setImageName((prevImageNames) => {
            const filteredNames = prevImageNames.filter(
              (item) => item.image && typeof item.image === "string" && item.image.trim() !== "",
            );
            if (
              payload.image &&
              typeof payload.image === "string" &&
              payload.image.trim() !== "" &&
              !filteredNames.some((item) => item.image === payload.image)
            ) {
              return [...filteredNames, payload.image];
            }
            return filteredNames;
          });
        } else {
          getMachineDatas();
        }
      }
    }
  }, [firstTwoDigits, middleThreeDigits, letterDigit, lastTwoDigits]);

  const fetchAndSendImage = async () => {
    try {
      setLoadingAi(true);
      await handleReadPlate();
    } catch (error) {
      setLoadingAi(false);
    }
  };

  const resetForm = () => {
    setTimeout(()=> {
      window.location.reload();
    },3000)
    return;
    setFirstTwoDigits("");
    setMiddleThreeDigits("");
    setLetterDigit("");
    setLastTwoDigits("");
    setSerial("");
    setGrossWeight("");
    setNetWeight("");
    setWeight(null);
    setDriverName("");
    setData("");
    setDataJensCodes({ id: "", title: "" });
    setMachine({ id: "", title: "" });
    setOrigin("");
    setDestination("");
    setBuyerName("");
    setSelectedValue("1");
    setImageName([]);
    setLoadingAi(false);
    setLoadingSubmit(false);
  };

  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const handleSubmit = async (withPrint) => {
    try {
      if (!firstTwoDigits.trim() && !middleThreeDigits.trim() && !letterDigit.trim() && !lastTwoDigits.trim()) {
        toast.error("ورود پلاک اجباری است!");
        return;
      }
      if (!machine.title || machine.title.trim() === "") {
        toast.error("انتخاب دستگاه اجباری است!");
        return;
      }

      setLoadingSubmit(true);
      const now = moment().format("HH:mm jYYYY/jMM/jDD");
      const pelak = `${firstTwoDigits}${letterDigit}${middleThreeDigits}${lastTwoDigits}`;

      const payload = {
        driver_id: null,
        jens_id: data?.id || null,
        jens_code_id: dataJensCode?.id || null,
        jens_code: dataJensCode || null,
        machine_id: machine?.id || null,
        origin: origin || null,
        destination: destination || null,
        image: imageName?.length > 0 ? imageName : null,
        plate: lastTwoDigits && middleThreeDigits && letterDigit && firstTwoDigits ? pelak : null,
        weight_empty: grossWeight || null,
        weight_fill: netWeight || null,
        type: selectedValue || null,
        buyer_name: buyerName || null,
        machine: { id: machine.id || null, name: machine.title || null, type: machine.type || null },
        driver: driverName,
        jens: data || null,
        created_at: now || null,
      };
      const payloadPdf = {

        origin: origin || null,
        destination: origin || null,

        // image: allImages || null,

        plate:
          firstTwoDigits &&
          middleThreeDigits &&
          letterDigit &&
          lastTwoDigits
            ? pelak
            : null,

        weight_empty: grossWeight || null,
        weight_fill: netWeight || null,

        type: "1",

        buyer_name: buyerName || null,

        machine: { id: machine.id || null, name: machine.title || null, type: machine.type || null },

        driver: driverName,

        jens: data?.title || null,

        created_at: now || null,
      };

      const token = Cookies.get("login_token");
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/Cargo/storeWeightBridge`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setLoadingSubmit(false);
      deleteRecordByCode(pelak);
      toast.success("اطلاعات با موفقیت ذخیره شد!");

      if (withPrint) {

        const blob = await pdf(<PdfReceiptWeight
          data={[{ ...payloadPdf, cargo_code: response?.data?.data?.cargo_code }]} />).toBlob();
        const base64PDF = await blobToBase64(blob);

        if (ws.current && ws.current.readyState === WebSocket.OPEN) {
          ws.current.send(JSON.stringify({ type: "print", title: base64PDF }));
          toast.success("فایل برای چاپ ارسال شد!");
        } else {
          toast.error("اتصال به سرور برقرار نیست!");
        }

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "bargo-report.pdf";
        link.click();
        setTimeout(() => URL.revokeObjectURL(link.href), 100);
      }
      resetForm();
    } catch (error) {
      setLoadingSubmit(false);
      if (error.response && error.response.status === 422) {
        toast.error("شماره قبض از قبل موجود است!");
      } else {
        console.log(error);
        toast.error("خطا در ذخیره اطلاعات!");
      }
    }
  };

  const handleClickSave = async () => {
    if (!firstTwoDigits.trim() && !middleThreeDigits.trim() && !letterDigit.trim() && !lastTwoDigits.trim()) {
      toast.error("ورود پلاک اجباری است!");
      return;
    }
    if (!machine.title || machine.title.trim() === "") {
      toast.error("انتخاب دستگاه اجباری است!");
      return;
    }
    const pelak = `${firstTwoDigits}${letterDigit}${middleThreeDigits}${lastTwoDigits}`;
    const now = moment().format("HH:mm jYYYY/jMM/jDD");
    const payloadPdf = {

      origin: origin || null,
      destination: destination || null,

      // image: allImages || null,

      plate:
        firstTwoDigits &&
        middleThreeDigits &&
        letterDigit &&
        lastTwoDigits
          ? pelak
          : null,

      weight_empty: grossWeight || null,
      weight_fill: netWeight || null,

      type: "1",

      buyer_name: buyerName || null,

      machine: { id: machine.id || null, name: machine.title || null, type: machine.type || null },

      driver: driverName,

      jens: data?.title || null,

      created_at: now || null,
    };
    savePayload(payloadPdf);
    resetForm();
  };

  const unitPrice = data && data.price ? Number(data.price) : null;
  const computedGross = grossWeight !== "" && netWeight !== "" ? Number(grossWeight) - Number(netWeight) : null;
  const payableAmount = unitPrice !== null && computedGross !== null && !isNaN(computedGross) ? computedGross * unitPrice : null;

  return (
    <>
      <ModalMachine setShowModal={setOpenModalMachine} showModal={openModalMachine} onSelectedIdsChange={(value) => {
        const plate = value?.plate || null;
        setMachine(value);
        if (value.driver) setDriverName({ id: value.driver.id, title: value.driver.name });
        if (plate) {
          setLastTwoDigits(plate.slice(6, 8));
          setMiddleThreeDigits(plate.slice(3, 6));
          setLetterDigit(plate.slice(2, 3));
          setFirstTwoDigits(plate.slice(0, 2));
        }
        setGrossWeight(value.empty_weight ?? 0);
      }} setData={""} />
      <ModalSelectJens setShowModal={setOpenModal} setData={""} onSelectedIdsChange={setData} showModal={openModal} />
      <ModalSelectJensCode setShowModal={setOpenModalJensCodes} setData={""} onSelectedIdsChange={setDataJensCodes}
                           showModal={openModalJensCode} />
      <ModalDriverSingle setShowModal={setOpenModalDriver} setData={""} onSelectedIdsChange={(d) => {
        setDriverName(d);
        setOpenModalDriver(false);
      }} showModal={openModalDriver} />
      <ModalSelectDestination setShowModal={setOpenModalDestination} setData={""} onSelectedIdsChange={(d) => {
        setDestination(d);
        setOpenModalDestination(false);
      }} showModal={openModalDestination} />
      <ModalSelectOrigin setShowModal={setOpenModalOrigin} setData={""} onSelectedIdsChange={(d) => {
        setOrigin(d);
        setOpenModalOrigin(false);
      }} showModal={openModalOrigin} />

      <DashboardLayout>
        <div style={{ minHeight: "100vh", backgroundColor: "#f0f2f5", direction: "rtl" }}>
          <Row gutter={[16, 16]}>
            {/* ----------------- بخش پلاک‌خوان ----------------- */}
            <Col xs={24} lg={8}>
              <Card
                title={<Space><CameraOutlined /> <Text strong>سیستم تشخیص پلاک</Text></Space>}
                bordered={false}
                className="shadow-sm"
                style={{ height: "100%", display: "flex", flexDirection: "column" }}
                bodyStyle={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}
              >
                <div style={{ width: "100%", paddingLeft: "20px", paddingRight: "20px" }}>
                  <div style={{
                    display: "flex", border: "2px solid #000", borderRadius: "8px", overflow: "hidden",
                    height: "60px", backgroundColor: "#fff", marginBottom: "24px", direction: "ltr",
                  }}>
                    <div style={{
                      width: "30px",
                      flexShrink: 0,
                      backgroundColor: "#003399",
                      color: "#fff",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "10px",
                      fontWeight: "bold",
                    }}>
                      <span>I.R.</span>
                      <span>IRAN</span>
                    </div>

                    <div style={{
                      flex: 1,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "4px",
                      padding: "0 4px",
                      marginLeft: "10px",
                      marginRight: "10px",
                      minWidth: 0,
                    }}>
                      <Input maxLength={2} value={firstTwoDigits} onChange={(e) => setFirstTwoDigits(e.target.value)}
                             style={{
                               flex: 1,
                               minWidth: 0,
                               textAlign: "center",
                               fontWeight: "bold",
                               fontSize: "16px",
                               padding: "4px 2px",
                             }} />

                      <Input maxLength={1} value={letterDigit} onChange={(e) => setLetterDigit(e.target.value)}
                             style={{
                               flex: 1,
                               minWidth: 0,
                               textAlign: "center",
                               fontWeight: "bold",
                               fontSize: "16px",
                               padding: "4px 2px",
                             }} />

                      <Input maxLength={3} value={middleThreeDigits}
                             onChange={(e) => setMiddleThreeDigits(e.target.value)}
                             style={{
                               flex: 1.5,
                               minWidth: 0,
                               textAlign: "center",
                               fontWeight: "bold",
                               fontSize: "16px",
                               padding: "4px 2px",
                             }} />

                      <Divider type="vertical" style={{ height: "30px", backgroundColor: "#000", margin: "0" }} />

                      <Input maxLength={2} value={lastTwoDigits} onChange={(e) => setLastTwoDigits(e.target.value)}
                             style={{
                               flex: 1,
                               minWidth: 0,
                               textAlign: "center",
                               fontWeight: "bold",
                               fontSize: "16px",
                               padding: "4px 2px",
                             }} />
                    </div>
                  </div>
                </div>


                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  <Button type="primary" size="large" icon={loadingAi ? <Spin
                    indicator={<LoadingOutlined style={{ fontSize: 15, color: "#ffffff" }} spin />}
                  /> : <CameraOutlined />} onClick={fetchAndSendImage} block>
                    {loadingAi ? "در حال پردازش..." : "ثبت پلاک و پردازش تصویر"}
                  </Button>
                  <Space>
                    <Switch checked={autoFill} onChange={() => setAutoFill(!autoFill)} />
                    <Text>تنظیم خودکار فیلدها</Text>
                  </Space>
                </div>
              </Card>
            </Col>

            {/* ----------------- تصویر زنده دوربین ----------------- */}
            <Col xs={24} lg={8}>
              <Card
                title={<Space><Badge status={connected ? "success" : "error"} /> <Text strong>تصویر
                  دوربین</Text></Space>}
                bordered={false}
                className="shadow-sm"
                bodyStyle={{ padding: 0 }}
                style={{ height: "100%" }}
              >
                <div style={{
                  backgroundColor: "#000",
                  height: "250px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}>
                  {!imagePlate ? (
                    <Text style={{ color: "#fff" }}>تصویری در دسترس نیست</Text>
                  ) : (
                    <img src={imagePlate} alt="تصویر پلاک"
                         style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  )}
                </div>
              </Card>
            </Col>

            <Col xs={24} lg={8}>
              <Card
                title={<Space><Badge status={connected ? "success" : "error"} /> <Text strong>نمایشگر
                  وزن</Text></Space>}
                bordered={false}
                className="shadow-sm"
                bodyStyle={{ padding: 0 }}
                style={{ height: "100%" }}
              >
                <div style={{ height: "250px" }} className="bg-gray-800 h-full  p-4 flex items-center justify-center">
                  <div className="flex items-center space-x-2">
                    <div className="flex items-center space-x-4">
          <span className="led-digit text-6xl font-bold text-green-500">
            {weight || "00000"}
          </span>
                      <span className="led-unit text-lg text-gray-400">KG</span>
                    </div>
                  </div>
                </div>
              </Card>

            </Col>

            {/* ----------------- فرم عملیات و بارنامه ----------------- */}
            <Col span={24}>
              <Card title={<Text strong>اطلاعات بارنامه و توزین</Text>} bordered={false} className="shadow-sm">

                {/* بخش ثبت وزن پر و خالی */}
                <Row gutter={[16, 24]} align="bottom" style={{
                  marginBottom: "32px",
                  backgroundColor: "#fafafa",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #e8e8e8",
                }}>
                  <Col xs={24} sm={12} md={5}>
                    <Text strong>توزین خالی:</Text>
                    <Input size="large" value={grossWeight} onChange={(e) => setGrossWeight(e.target.value)} suffix="KG"
                           style={{ marginTop: "8px" }} />
                  </Col>
                  <Col xs={24} sm={12} md={4}>
                    <Button type="primary" size="large" block onClick={() => {
                      setGrossWeight(weight);
                      toast.success("توزین خالی ثبت شد!");
                    }}>
                      ثبت وزن جاری
                    </Button>
                  </Col>

                  <Col xs={24} sm={12} md={5}>
                    <Text strong>توزین پر:</Text>
                    <Input size="large" value={netWeight} onChange={(e) => setNetWeight(e.target.value)} suffix="KG"
                           style={{ marginTop: "8px" }} />
                  </Col>
                  <Col xs={24} sm={12} md={4}>
                    <Button type="primary" size="large" block onClick={() => {
                      setNetWeight(weight);
                      toast.success("توزین پر ثبت شد!");
                    }}>
                      ثبت وزن جاری
                    </Button>
                  </Col>

                  <Col xs={24} md={6}>
                    <Button danger size="large" icon={<ClearOutlined />} block onClick={() => {
                      setGrossWeight("");
                      setNetWeight("");
                      toast.info("اطلاعات پاک شدند!");
                    }}>
                      پاک کردن
                    </Button>
                  </Col>
                </Row>

                <Row gutter={[16, 24]}>
                  <Col xs={24} sm={12} md={8}>
                    <Text strong>انتخاب دستگاه</Text>
                    <Input size="large" readOnly={autoFill} value={machine?.title} onClick={() => {
                      if (autoFill) setOpenModalMachine(true);
                    }} onChange={(e) => setMachine({ title: e.target.value })}
                           style={{ marginTop: "8px", cursor: autoFill ? "pointer" : "text" }} />
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <Text strong>انتخاب راننده</Text>
                    <Input size="large" value={driverName} onChange={(e) => setDriverName(e.target.value)}
                           style={{ marginTop: "8px", cursor: autoFill ? "pointer" : "text" }} />
                  </Col>

                  {/*<Col xs={24} sm={12} md={8}>*/}
                  {/*  <Text strong>نوع عملیات</Text>*/}
                  {/*  <Select size="large" value={selectedValue} onChange={handleChange} style={{ width: '100%', marginTop: '8px' }}>*/}
                  {/*    <Option value="1">بارگیری</Option>*/}
                  {/*    <Option value="2">تخلیه بار</Option>*/}
                  {/*  </Select>*/}
                  {/*</Col>*/}

                  <Col xs={24} md={12} lg={8}>
                    <Text strong>کالا</Text>
                    <Input.Group compact style={{ display: "flex", marginTop: "8px" }}>
                      <Input
                        size="large"
                        style={{
                          width: "30%",
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                        }}
                        type="number"
                        placeholder="کد"
                        prefix={<span style={{ color: "#999", fontSize: "12px" }}>#</span>}
                        onPressEnter={async (e) => {
                          const code = e.target.value;
                          if (!code) return;

                          try {
                            const token = Cookies.get("login_token");
                            if (!token) {
                              handleUnauthorized();
                            }
                            const response = await fetch(`${process.env.REACT_APP_API_URL}/Jens/${code}`, {
                              headers: {
                                Authorization: `Bearer ${token}`,
                              },
                            });

                            if (response.ok) {
                              const data = await response.json();
                              setData({ id: data?.id, title: data?.title });
                            } else if (response.status === 404) {
                              toast.error("کالا با این کد یافت نشد");
                            } else {
                              toast.error("خطا در دریافت اطلاعات");
                            }
                          } catch (_) {
                            toast.error("خطا در ارتباط با سرور");
                          }
                        }}
                      />
                      <Input
                        rules={[{ required: true, message: "کالا اجباری است" }]}
                        size="large"
                        style={{
                          width: "70%",
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0,
                        }}
                        placeholder="انتخاب کالا"
                        value={typeof data === "object"
                          ? data?.title || ""
                          : data || ""}
                        readOnly={true}
                      >

                      </Input>
                    </Input.Group>
                  </Col>

                  <Col xs={24} md={12} lg={8}>
                    <Text strong>مشتری</Text>
                    <Input.Group compact style={{ display: "flex", marginTop: "8px" }}>
                      <Input
                        size="large"
                        style={{
                          width: "30%",
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                        }}
                        type="number"
                        placeholder="کد"
                        prefix={<span style={{ color: "#999", fontSize: "12px" }}>#</span>}
                        onPressEnter={async (e) => {
                          const code = e.target.value;
                          if (!code) return;

                          try {
                            const token = Cookies.get("login_token");
                            if (!token) {
                              handleUnauthorized();
                            }
                            const response = await fetch(`${process.env.REACT_APP_API_URL}/Purchasor/${code}`, {
                              headers: {
                                Authorization: `Bearer ${token}`,
                              },
                            });


                            if (response.ok) {
                              const data = await response.json();
                              setBuyerName(data?.name);

                            } else if (response.status === 404) {
                              toast.error("مشتری با این کد یافت نشد");
                            } else {
                              toast.error("خطا در دریافت اطلاعات");
                            }
                          } catch (e) {
                            console.log(e);
                            toast.error("خطا در ارتباط با سرور");
                          }
                        }}
                      />
                      <Input
                        size="large"
                        style={{
                          width: "70%",
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0,
                        }}
                        placeholder="انتخاب مشتری"
                        value={buyerName}
                      />
                    </Input.Group>
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <Text strong>انتخاب مبدا</Text>
                    <Input size="large" value={origin} style={{ marginTop: "8px", cursor: "pointer" }}
                           onChange={(e) => setOrigin(e.target.value)} />
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <Text strong>انتخاب مقصد</Text>
                    <Input size="large" value={destination} style={{ marginTop: "8px", cursor: "pointer" }}
                           onChange={(e) => setDestination(e.target.value)} />
                  </Col>
                </Row>

                <Divider />

                <Row gutter={16} justify="end">
                  <Col xs={24} sm={12} md={6} className={"pb-2"}>
                    <Button size="large" icon={<PrinterOutlined />} onClick={handleClickSave} block
                            style={{ backgroundColor: "#309100", color: "#fff" }}>
                      ثبت موقت
                    </Button>
                  </Col>
                  <Col xs={24} sm={12} md={6}>
                    <Button type="primary" size="large" icon={<SaveOutlined />} onClick={() => handleSubmit(true)}
                            disabled={loadingSubmit} block style={{ backgroundColor: "#1890ff" }}>
                      {loadingSubmit ? "در حال پردازش..." : "صدور نهایی قبض باسکول"}
                    </Button>
                  </Col>
                </Row>

              </Card>
            </Col>
          </Row>
        </div>
      </DashboardLayout>
    </>
  );
}
